import HelpPage from "./help/ui/HelpPage.tsx";

export default function Help() {
    return <HelpPage />;
}
